import { h, Component, Prop } from '@stencil/core';


@Component({
  tag: 'tip-redirect'
})
export class Redirect {
  @Prop() label: string = 'https://ccrpc.org/tip';
  @Prop() url: string = 'https://ccrpc.org/tip';

  render() {
    return (
      <a href={this.url}>
        {this.label}
      </a>
    );
  }
}
